import { useQuery } from 'react-query'

import { getFinancialAccountUseCase } from '@webapp/platform/banking/business-logic/use-cases/GetFinancialAccount'
import { financialAccountKeys } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository/queryKey.factory'
import { FinancialAccount } from '@webapp/platform/banking/entities/FinancialAccount'

type UseQueryFinancialAccountReturn = {
  financialAccount: Nullable<FinancialAccount>
  isFetching: boolean
}

export const useQueryFinancialAccount = ({
  onError,
  enabled = true,
}: {
  onError: () => void
  enabled?: boolean
}): UseQueryFinancialAccountReturn => {
  const { data, isFetching } = useQuery({
    queryKey: financialAccountKeys.getFinancialAccount,
    queryFn: () => getFinancialAccountUseCase(),
    enabled,
    onError,
    staleTime: 5000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })

  const financialAccount = data?.data

  return {
    financialAccount: financialAccount
      ? new FinancialAccount(financialAccount)
      : null,
    isFetching,
  }
}
